const DEFAULT_LANG = 'en'
const INTERNAL_LANGS = ['en', 'zh']
const URL_LANG_MAP = {
  en: 'en',
  zh: 'zh-CN'
}

const normalizeLang = (lang) => {
  if (!lang || typeof lang !== 'string') return ''
  const normalized = lang.trim().toLowerCase()
  if (normalized === 'en' || normalized === 'en-us') return 'en'
  if (normalized === 'zh' || normalized === 'zh-cn' || normalized === 'zn')
    return 'zh'
  return ''
}

const toUrlLang = (internalLang) => URL_LANG_MAP[internalLang] || URL_LANG_MAP.en

export const getLang = () => {
  const params = new URLSearchParams(window.location.search)
  const urlLang = normalizeLang(params.get('lang'))
  if (urlLang) {
    localStorage.setItem('lang', urlLang)
    return urlLang
  }

  const storedLang = normalizeLang(localStorage.getItem('lang'))
  if (storedLang && INTERNAL_LANGS.includes(storedLang)) {
    return storedLang
  }

  return DEFAULT_LANG
}

export const setLang = (lang) => {
  const normalizedLang = normalizeLang(lang)
  if (!normalizedLang || !INTERNAL_LANGS.includes(normalizedLang)) {
    console.warn(`不支持的语言: ${lang}`)
    return
  }

  localStorage.setItem('lang', normalizedLang)
  window.dispatchEvent(
    new CustomEvent('langchange', { detail: { lang: normalizedLang } })
  )

  const url = new URL(window.location.href)
  url.searchParams.set('lang', toUrlLang(normalizedLang))
  window.location.href = url.toString()
}

export const toggleLang = () => {
  const currentLang = getLang()
  const newLang = currentLang === 'en' ? 'zh' : 'en'
  setLang(newLang)
}

export const isZh = () => getLang() === 'zh'
export const isEn = () => getLang() === 'en'
export const getUrlLang = () => toUrlLang(getLang())
export const t = (i18nObj, fallback = '') => {
  if (typeof i18nObj === 'string') {
    return i18nObj
  }

  if (typeof i18nObj !== 'object' || i18nObj === null) {
    return fallback
  }

  const lang = getLang()
  return i18nObj[lang] || i18nObj['en'] || fallback
}

export const selectLangData = (data) => {
  if (!data) return data

  if (data.en && data.zh) {
    const lang = getLang()
    return data[lang] || data['en']
  }

  return data
}

export const langHref = (href) => {
  if (!href || href.startsWith('#')) return href

  try {
    const url = new URL(href, window.location.origin)
    url.searchParams.set('lang', getUrlLang())
    return url.pathname + url.search + url.hash
  } catch {
    const separator = href.includes('?') ? '&' : '?'
    return `${href}${separator}lang=${getUrlLang()}`
  }
}

export const CURRENT_LANG = getLang()

export const applyLangClass = () => {
  const lang = getLang()
  const htmlLang = lang === 'zh' ? 'zh-CN' : 'en'
  document.documentElement.setAttribute('lang', htmlLang)
  document.body.classList.remove('lang-en', 'lang-zh')
  document.body.classList.add(`lang-${lang}`)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLangClass)
  } else {
    applyLangClass()
  }
}
